import { useEffect, useState } from 'react';

/**
 * Subscribes to a CSS media query and re-renders when it flips. SSR-safe
 * (this app is CSR-only, but matchMedia isn't available during any
 * server-rendered pass or in test environments without a DOM).
 */
export const useMediaQuery = (query) => {
  const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    // addEventListener on MediaQueryList is broadly supported; addListener
    // is the legacy fallback for older Safari.
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler);
      return () => mql.removeEventListener('change', handler);
    }
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, [query]);

  return matches;
};

// Tailwind's default `xl` breakpoint — the threshold used across the
// dashboard for the wide-screen / master-detail layout pass (2026-09).
export const XL_QUERY = '(min-width: 1280px)';
export const useIsWideScreen = () => useMediaQuery(XL_QUERY);
